import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";

import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import {
  customTextColor,
  getFormattedDate,
  whichFile,
} from "../../../utils/const";
import { useLocation, useNavigate } from "react-router-dom";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiNewspaperClippingLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { PiMapPinSimpleAreaLight } from "react-icons/pi";
import { IoIosAdd } from "react-icons/io";
import { time_zone_choices, work_preference } from "../../../utils/const2";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addSubmissionCandidate,
  getOneSubmissionTracker,
} from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import { addLocation, allLocation } from "../../../redux/common/locationSlice";
import {
  addWorkAuthorization,
  allWorkAuthorization,
} from "../../../redux/common/workAuthorizationSlice";
import { resumeProcces } from "../../../redux/internal-tracking/InternalTrackerSlice";
import { IoIosArrowRoundBack } from "react-icons/io";
import Swal from "sweetalert2";
import { getProfile } from "../../../redux/profile/profileSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import { allSkill } from "../../../redux/common/skillSlice";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const bestTimevalue = [
  {
    name: "Today",
    value: "today",
  },
  {
    name: "Tomorrow",
    value: "tomorrow",
  },
  {
    name: "Day After Tomorrow",
    value: "day after tomorrow",
  },
];

const AddCandidateInRequirementDrawer = ({
  handleClose,
  show,
  row,
  setDataview,
  setData,
  candidateListDetails,
}) => {
  const [selectedFileName, setSelectedFileName] = useState("");
  const [base64Resume, setBase64Resume] = useState();
  const [resumeError, setResumeError] = useState(false);
  const [locationIds, setLocationIds] = useState([]);
  const [workAuthorizeIds, setWorkAuthorizeIds] = useState([]);
  const [shrink, setShrink] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { type } = location.state || {};
  const { candidates } = location.state || [];

  const locations = useSelector((state) => state.location);
  const workautho = useSelector((state) => state.workautho);
  const skillData = useSelector((state) => state.skill.data);

  const addCandidateStatus = useSelector(
    (state) => state.trackersubmission.status
  );
  const internalSubStatus = useSelector(
    (state) => state.trackersubmission.status
  );
  const trackerLoading = useSelector((state) => state.tracker.status);
  const postData = useSelector((state) => state.trackersubmission.postData);

  const resumeData = useSelector((state) => state.tracker.resumeData);
  const profile = useSelector((state) => state.profile.data);
  const formik = useFormik({
    initialValues: {
      full_name: "",
      // gender: "",
      mobile_no: "",
      email: "",
      current_location: "",
      prefer_location: [],
      work_authorization: "",
      work_preference: "",
      current_job_title: "",
      total_experience: "",
      p_tax_team: [],
      prefer_tax_team: "full_Time",
      rate: null,
      // employer_company_name: "",
      employer_manager_name: "",
      // employer_mobile_no: "",
      employer_email: "",
      requirement: row?.requirement_id,
      resume: "",
      internal_candidate: "",
      highest_qualification: "",
      university: "",
      organization: "",
      domain_and_industry: "",
      ssn_number: "",
      best_time_to_call: null,
      best_time: null,
      time_zone: "",
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      mobile_no: Yup.string().required("Mobile Number is required"),
      email: Yup.string().required("Email is required"),
      current_location: Yup.string().required("Current Location is required"),
      prefer_location: Yup.array()
        .of(Yup.string())
        .min(1, "Prefer Location is required")
        .required("Prefer Location is required"),
      work_authorization: Yup.string().required(
        "work Authorization is required"
      ),
      p_tax_team: Yup.array()
        .of(Yup.string()) // Ensures the array contains strings
        .min(1, "Prefer Tax Term is required") // Ensures there's at least one value
        .required("Prefer Tax Term is required"),

      work_preference: Yup.string().required("Work Preference is required"),
      current_job_title: Yup.string().required("Current Job Title required"),
      // rate: Yup.string().required("Rate is required"),
      total_experience: Yup.string().required("Experience is required"),
      best_time: Yup.string().required("Time is required"),
      employer_manager_name: Yup.string().when(
        "p_tax_team",
        ([p_tax_team = []], schema) =>
          p_tax_team.includes("full_Time")
            ? schema.notRequired()
            : schema.required("Employer Manager Name is required")
      ),

      employer_email: Yup.string().when(
        "p_tax_team",
        ([p_tax_team = []], schema) =>
          p_tax_team.includes("full_Time")
            ? schema.notRequired()
            : schema
                .email("Invalid email format")
                .required("Employer Email is required")
      ),

      time_zone: Yup.string().required("Time Zone is required"),
    }),
    onSubmit: (values) => {
      const userData = {
        ...values,
        willing_to_relocate: false,
        familiar_to_job_description: false,
        authorized_to_discuss_about_rate: false,
        best_time_to_call: getFormattedDate(
          values.best_time_to_call,
          values.best_time
        ),
      };

      // Filter out null, empty string, or empty array values
      const cleanedData = Object.fromEntries(
        Object.entries(userData).filter(([_, value]) => {
          if (Array.isArray(value)) return value.length > 0;
          return value !== null && value !== "";
        })
      );
      if (values?.resume === null || values?.resume === "") {
        const { resume, ...updatedValues } = cleanedData;

        dispatch(addSubmissionCandidate(updatedValues));
      } else {
        let updatedValues = cleanedData;

        dispatch(addSubmissionCandidate(updatedValues));
      }

      localStorage.setItem(
        "internalSubmissionDetails",
        JSON.stringify({ row, type: "view" })
      );
    },
  });

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const checkCandidateExists = (email, mobileNo) => {
    const exists = candidates?.some(
      (candidate) =>
        candidate?.email === email || candidate?.mobile_no === mobileNo
    );

    if (exists) {
      Swal.fire({
        icon: "info",
        title: "Candidate Already Exists",
        text: "This candidate is already in the system. please fill data again.",
      }).then(() => {
        // formik.resetForm({
        //   values: {
        //     full_name: "",
        //     // gender: "",
        //     mobile_no: "",
        //     email: "",
        //     current_location: "",
        //     prefer_location: "",
        //     work_authorization: "",
        //     p_tax_team: "",
        //     employer_company_name: "",
        //     employer_manager_name: "",
        //     employer_mobile_no: "",
        //     employer_email: "",
        //     work_preference: "",
        //     current_job_title: "",
        //     total_experience: "",
        //     rate: "",
        //     resume: "",
        //     requirement_tracker: row?.requirement_id,
        //   },
        // });
        // setBase64Resume("");
        // setSelectedFileName("");
      });
    }
  };

  useEffect(() => {
    if (addCandidateStatus === "add_candidate_to_submission") {
      localStorage.setItem(
        "internalSubmissionDetailsWhichView",
        JSON.stringify({ type: "added", row })
      );
      setDataview({ type: "added" });
      setData({ row, type: "view" });
      formik.resetForm({
        values: {
          full_name: "",
          // gender: "",
          mobile_no: "",
          email: "",
          current_location: "",
          prefer_location: "",
          work_authorization: "",
          p_tax_team: "",
          employer_company_name: "",
          employer_manager_name: "",
          employer_mobile_no: "",
          employer_email: "",
          work_preference: "",
          current_job_title: "",
          total_experience: "",
          rate: "",
          resume: "",
          internal_candidate: "",
          highest_qualification: "",
          university: "",
          organization: "",
          domain_and_industry: "",
          ssn_number: "",
          best_time_to_call: null,
          skills: "",
          requirement: row?.requirement_id,
        },
      });
      setBase64Resume("");
      setSelectedFileName("");
      let id = row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
    }
  }, [addCandidateStatus, row]);

  // useEffect(() => {
  //   if (resumeData && selectedFileName !== "") {
  //     formik.setFieldValue(
  //       "full_name",
  //       resumeData?.data?.processed_json?.name || ""
  //     );

  //     formik.setFieldValue(
  //       "total_experience",
  //       resumeData?.data?.processed_json?.total_experience || ""
  //     );

  //     formik.setFieldValue(
  //       "mobile_no",
  //       resumeData?.data?.processed_json?.phone || ""
  //     );

  //     formik.setFieldValue(
  //       "email",
  //       resumeData?.data?.processed_json?.email || ""
  //     );

  //     formik.setFieldValue(
  //       "current_job_title",
  //       resumeData?.data?.processed_json?.job_profile || ""
  //     );

  //     formik.setFieldValue(
  //       "p_tax_team",
  //       resumeData?.data?.processed_json?.prefer_tax_term || ""
  //     );

  //     formik.setFieldValue(
  //       "work_authorization",
  //       resumeData?.data?.processed_json?.work_authorization || ""
  //     );
  //   }
  // }, [resumeData, selectedFileName]);

  const handleFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("full_name", value);
    }
  };

  const handleEmployerFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("employer_manager_name", value);
    }
  };

  // const handleMobileNoChange = (e) => {
  //   const value = e.target.value;
  //   if (/^\d*$/.test(value) && value.length <= 10) {
  //     formik.setFieldValue("mobile_no", value);
  //   }
  // };

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("mobile_no", value);
    }
  };

  const handleEmployerMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("employer_mobile_no", value);
    }

    // const value = e.target.value;
    // if (/^\d*$/.test(value) && value.length <= 10) {
    //   formik.setFieldValue("employer_mobile_no", value);
    // }
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  useEffect(() => {
    if (row) {
      formik.setFieldValue("requirement", row?.requirement_id || "");
    }
  }, [row]);

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       // Extract the base64 encoded string from the file
  //       const base64String = reader.result.split(",")[1];
  //       setBase64Resume(base64String);
  //       // Extract base64 portion
  //       setSelectedFileName(file.name);
  //       setSelectedFileName(file.name);
  //       const formData = new FormData();
  //       formData.append("resume_file", file);
  //       dispatch(resumeProcces(formData));
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Extract the base64 encoded string from the file
        const base64String = reader.result.split(",")[1];
        // Prefix the base64 string with MIME type
        const fileExtension = file.name.split(".").pop().toLowerCase();

        const formattedBase64 = `data:${whichFile(
          fileExtension
        )};base64,${base64String}`;

        setBase64Resume(formattedBase64);

        // Set file name and prepare form data
        setSelectedFileName(file.name);
        const formData = new FormData();
        formData.append("resume_file", file);

        dispatch(resumeProcces(formData));
      };

      reader.readAsDataURL(file);
    }
  };

  const handleOnCLickBack = () => {
    localStorage.setItem(
      "internalSubmissionDetails",
      JSON.stringify({ row, type: "view" })
    );
    handleClose();
    // if (type === "view") {
    //   navigate("/submision-tracker");
    //   localStorage.setItem(
    //     "internalSubmissionDetails",
    //     JSON.stringify({ row, type: "view" })
    //   );
    // } else {
    //   navigate("/internal-tracker-submissions", {
    //     state: { row: row, type: "added" },
    //   });
    // }
  };

  useEffect(() => {
    if (!resumeData || !locations) return;
    const checkAndAddLocation = async (locations, resumeData) => {
      // Extract all locations and current location
      const allLocation = locations?.data?.locations || [];
      const currentLocation =
        resumeData?.data?.processed_json?.current_location;

      if (!currentLocation) {
        // console.error("Current location is not provided in resumeData.");
        return null;
      }

      // Check if the current location exists in allLocation
      const existingLocation = allLocation.find(
        (location) =>
          location.name.toLowerCase() === currentLocation.toLowerCase()
      );

      if (existingLocation) {
        // If found, return the existing ID

        return existingLocation.id;
      } else {
        // If not found, dispatch the action to add the location
        try {
          const newLocation = await dispatch(
            addLocation({ name: currentLocation })
          );
          return newLocation?.id || null;
        } catch (error) {
          throw new Error("Could not add location");
        }
      }
    };
    (async () => {
      const locationId = await checkAndAddLocation(locations, resumeData);
      setLocationIds(locationId);
    })();
  }, [resumeData]);

  useEffect(() => {
    if (!resumeData || !workautho) return;
    const checkAndAddLocation = async (workautho, resumeData) => {
      // Extract all locations and current location
      const allLocation = workautho?.data?.work_authorization_data || [];
      const currentLocation =
        resumeData?.data?.processed_json?.work_authorization;

      if (!currentLocation) {
        return null;
      }

      // Check if the current location exists in allLocation
      const existingLocation = allLocation.find(
        (location) =>
          location.name.toLowerCase() === currentLocation.toLowerCase()
      );

      if (existingLocation) {
        // If found, return the existing ID

        return existingLocation.id;
      } else {
        // If not found, dispatch the action to add the location
        try {
          const newLocation = await dispatch(
            addWorkAuthorization({ name: currentLocation })
          );
          return newLocation?.id || null;
        } catch (error) {
          throw new Error("Could not add location");
        }
      }
    };
    (async () => {
      const locationId = await checkAndAddLocation(workautho, resumeData);
      setWorkAuthorizeIds(locationId);
    })();
  }, [resumeData]);

  useEffect(() => {
    if (locationIds) {
      formik.setFieldValue("current_location", locationIds);
    }
  }, [locationIds]);

  useEffect(() => {
    if (workAuthorizeIds) {
      formik.setFieldValue("work_authorization", workAuthorizeIds);
    }
  }, [workAuthorizeIds]);

  useEffect(() => {
    formik.setFieldValue("resume", base64Resume || null);
    setResumeError(false);
  }, [base64Resume]);

  const handleRateChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 3) {
      formik.setFieldValue("rate", value);
    }
  };

  useEffect(() => {
    if (formik?.values?.mobile_no && formik?.values?.email) {

      checkCandidateExists(formik.values.email, formik.values.mobile_no);
    }
  }, [formik?.values?.email, formik?.values?.mobile_no]);

  useEffect(() => {
    dispatch(getProfile());
    dispatch(allSkill());
  }, []);

  let prefer_tax_term;
  if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
    prefer_tax_term = [
      { id: "contract", name: "Contract" },
      { id: "contract_to_hire", name: "Contract To Hire" },
    ];
  } else {
    prefer_tax_term = [
      { id: "contract", name: "Contract" },
      { id: "contract_to_hire", name: "Contract To Hire" },
      { id: "full_Time", name: "Fulltime" },
      { id: "w2_with_benefit", name: "W2 Hourly Benefit" },
      { id: "w2_without_benefit", name: "W2 Hourly No Benefit" },
      { id: "1099", name: "1099" },
      { id: "working_in_all", name: "All" },
    ];
  }

  useEffect(() => {
    if (candidateListDetails && selectedFileName === "") {
      formik.setFieldValue("full_name", candidateListDetails?.full_name || "");

      formik.setFieldValue(
        "total_experience",
        candidateListDetails?.total_experience || ""
      );
      // }

      formik.setFieldValue("mobile_no", candidateListDetails?.mobile_no || "");

      formik.setFieldValue("email", candidateListDetails?.email || "");

      formik.setFieldValue(
        "current_job_title",
        candidateListDetails?.current_job_title || ""
      );

      formik.setFieldValue(
        "p_tax_team",
        candidateListDetails?.p_tax_team || []
      );

      formik.setFieldValue(
        "current_location",
        candidateListDetails?.current_location || ""
      );
      formik.setFieldValue(
        "prefer_location",
        candidateListDetails?.prefer_location || []
      );
      formik.setFieldValue(
        "work_preference",
        candidateListDetails?.work_preference || ""
      );
      formik.setFieldValue(
        "work_authorization",
        candidateListDetails?.work_authorization || ""
      );
      formik.setFieldValue("rate", candidateListDetails?.rate || "");
      formik.setFieldValue(
        "internal_candidate",
        candidateListDetails?.id || ""
      );
      formik.setFieldValue(
        "university",
        candidateListDetails?.university || ""
      );
      formik.setFieldValue(
        "highest_qualification",
        candidateListDetails?.highest_qualification || ""
      );
      formik.setFieldValue(
        "domain_and_industry",
        candidateListDetails?.domain_name || ""
      );
      formik.setFieldValue(
        "organization",
        candidateListDetails?.current_company || ""
      );

      formik.setFieldValue("time_zone", candidateListDetails?.time_zone || "");
      formik.setFieldValue("skills", candidateListDetails?.skills || "");
    }
  }, [candidateListDetails, selectedFileName]);

  const getSkillNames = (skills) => {
    return skills
      ?.map(
        (id) => skillData?.locations?.find((skill) => skill.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "65%",
        // padding: "0 0 0 10px",
        backgroundColor: "#f5f5f5",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          padding: "10px 10px 10px 0",
          margin: "0 15px",
        }}
      >
        <Box></Box>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ padding: "0" }}>
        <Box className={styles.add_structure}>
          <Box className={styles.upload_resume_section}>
            <Box>
              <Typography sx={{ fontSize: "16px !important" }}>
                {" "}
                Powerful AI capable to extract all required information from the
                resume but make sure <br />
                that information’s must have in uploaded resume.
              </Typography>
              <Typography
                sx={{
                  marginBottom: "0 !important",
                  fontSize: "20px !important",
                }}
              >
                <b>Don’t miss out your feedback by Tracking Submission </b>
              </Typography>
            </Box>
            <div style={{ display: "flex", alignSelf: "flex-end" }}>
              <button
                onClick={handleButtonClick}
                disabled={
                  trackerLoading === "loading" ||
                  internalSubStatus === "loading"
                }
                style={
                  trackerLoading === "loading" ||
                  internalSubStatus === "loading"
                    ? {
                        display: "flex",
                        alignSelf: "flex-end",
                        padding: "7px 40px",
                      }
                    : { display: "flex", alignSelf: "flex-end" }
                }
              >
                {trackerLoading === "loading" || internalSubStatus === "loading"
                  ? // <CircularProgress size={12} sx={{ color: "#fff" }} />
                    "Loading"
                  : "Upload Resume"}
              </button>
              <input
                id="fileInput"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              {selectedFileName && (
                <p
                  style={{
                    marginTop: "6px",
                    fontSize: "14px",
                    color: "#1b89de",
                  }}
                >
                  Selected file: {selectedFileName}
                </p>
              )}

              {resumeError === true ? (
                <div className={styles.error}>upload resume is required</div>
              ) : null}
            </div>
          </Box>
          <form onSubmit={formik.handleSubmit}>
            <Grid container className={styles.candidate_field_section}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiUserLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Name"
                  variant="standard"
                  name="full_name"
                  onChange={handleFullNameChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.full_name}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "full_name" || formik.values.full_name !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("full_name");
                  }}
                />
                {formik.touched.full_name && formik.errors.full_name ? (
                  <div className={styles.error}>{formik.errors.full_name}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiMobile3 style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Work Phone No"
                  variant="standard"
                  type="text"
                  name="mobile_no"
                  onChange={handleMobileNoChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobile_no}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "mobile_no" || formik.values.mobile_no !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("mobile_no");
                  }}
                />
                {formik.touched.mobile_no && formik.errors.mobile_no ? (
                  <div className={styles.error}>{formik.errors.mobile_no}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMailboxLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Work E-Mail ID"
                  variant="standard"
                  type="text"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink: shrink === "email" || formik.values.email !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("email");
                  }}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className={styles.error}>{formik.errors.email}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiChairLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Job Profile"
                  variant="standard"
                  type="text"
                  name="current_job_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.current_job_title}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "current_job_title" ||
                      formik.values.current_job_title !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("current_job_title");
                  }}
                />
                {formik.touched.current_job_title &&
                formik.errors.current_job_title ? (
                  <div className={styles.error}>
                    {formik.errors.current_job_title}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiAddressBookLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Total Experience"
                  variant="standard"
                  type="text"
                  name="total_experience"
                  // onChange={formik.handleChange}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                    formik.setFieldValue("total_experience", rawValue);
                  }}
                  onBlur={formik.handleBlur}
                  // value={formik.values.total_experience}
                  value={
                    formik.values.total_experience
                      ? `${formik.values.total_experience} ${
                          formik.values.total_experience > 1 ? "Years" : "Year"
                        }`
                      : ""
                  }
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "total_experience" ||
                      formik.values.total_experience !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("total_experience");
                  }}
                />
                {formik.touched.total_experience &&
                formik.errors.total_experience ? (
                  <div className={styles.error}>
                    {formik.errors.total_experience}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  select
                  id="standard-basic"
                  label="Currecnt Locations"
                  variant="standard"
                  name="current_location"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.current_location}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "current_location" ||
                      formik.values.current_location !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("current_location");
                  }}
                >
                  {locations?.data?.locations?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.current_location &&
                formik.errors.current_location ? (
                  <div className={styles.error}>
                    {formik.errors.current_location}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Box className={styles.icon_style} style={{ left: "7px" }}>
                    <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
                  </Box>

                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={locations?.data?.locations || []}
                    disableCloseOnSelect
                    value={
                      locations?.data?.locations?.filter((location) =>
                        formik.values.prefer_location?.includes(location.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const selectedLocations = value?.map(
                        (location) => location?.id
                      );
                      formik.setFieldValue(
                        "prefer_location",
                        selectedLocations
                      );
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option?.name || ""}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>{" "}
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Preferred Location"
                        variant="standard"
                        size="small"
                        name="prefer_location"
                        sx={fieldStyle}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />
                </Box>
                {formik.touched.prefer_location &&
                formik.errors.prefer_location ? (
                  <div className={styles.error}>
                    {formik.errors.prefer_location}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
                </Box>

                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={prefer_tax_term || []}
                  disableCloseOnSelect
                  value={
                    prefer_tax_term?.filter((tax_term) =>
                      formik.values.p_tax_team?.includes(tax_term.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedPrefertaxterm = value?.map(
                      (tax_term) => tax_term?.id
                    );
                    formik.setFieldValue("p_tax_team", selectedPrefertaxterm);
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Hiring Mode"
                      variant="standard"
                      size="small"
                      name="p_tax_team"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />

                {formik.touched.p_tax_team && formik.errors.p_tax_team ? (
                  <div className={styles.error}>{formik.errors.p_tax_team}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  label="Work Preference"
                  variant="standard"
                  select
                  name="work_preference"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_preference}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "work_preference" ||
                      formik.values.work_preference !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("work_preference");
                  }}
                >
                  {work_preference.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_preference &&
                formik.errors.work_preference ? (
                  <div className={styles.error}>
                    {formik.errors.work_preference}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiIdentificationCardLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  select
                  id="standard-basic"
                  label="Work Authorization"
                  variant="standard"
                  type="text"
                  name="work_authorization"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_authorization}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "work_authorization" ||
                      formik.values.work_authorization !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("work_authorization");
                  }}
                >
                  {workautho?.data?.work_authorization_data?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_authorization &&
                formik.errors.work_authorization ? (
                  <div className={styles.error}>
                    {formik.errors.work_authorization}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiIdentificationCardLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="hugeicons:save-money-dollar"
                    height={25}
                    width={25}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label={
                    formik?.values?.p_tax_team?.includes("full_Time")
                      ? "Salary (Optional)"
                      : "Rate (Optional)"
                  }
                  variant="standard"
                  type="text"
                  name="rate"
                  // onChange={handleRateChange}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                    // formik.setFieldValue("rate", rawValue);
                    if (rawValue.length <= 3) {
                      formik.setFieldValue("rate", rawValue); // Set value only if length <= 3
                    }
                  }}
                  onBlur={formik.handleBlur}
                  // value={formik.values.rate}
                  value={
                    formik.values.rate
                      ? `$${formik.values.rate} ${
                          formik?.values?.p_tax_team?.includes("full_Time")
                            ? "Yearly"
                            : "Hourly"
                        }`
                      : ""
                  }
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink: shrink === "rate" || formik.values.rate !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("rate");
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="carbon:education" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Highest Qualification"
                  variant="standard"
                  type="text"
                  name="highest_qualification"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.highest_qualification}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "highest_qualification" ||
                      formik.values.highest_qualification !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("highest_qualification");
                  }}
                />
                {formik.touched.highest_qualification &&
                formik.errors.highest_qualification ? (
                  <div className={styles.error}>
                    {formik.errors.highest_qualification}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="hugeicons:university" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="University & Passing in"
                  variant="standard"
                  type="text"
                  name="university"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.university}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "university" ||
                      formik.values.university !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("university");
                  }}
                />
                {formik.touched.university && formik.errors.university ? (
                  <div className={styles.error}>{formik.errors.university}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="ph:building-office" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Recent Organization"
                  variant="standard"
                  type="text"
                  name="organization"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.organization}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "organization" ||
                      formik.values.organization !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("organization");
                  }}
                />
                {formik.touched.organization && formik.errors.organization ? (
                  <div className={styles.error}>
                    {formik.errors.organization}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="heroicons:building-office"
                    height={25}
                    width={25}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Domain & Industry"
                  variant="standard"
                  type="text"
                  name="domain_and_industry"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.domain_and_industry}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "domain_and_industry" ||
                      formik.values.domain_and_industry !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("domain_and_industry");
                  }}
                />
                {formik.touched.domain_and_industry &&
                formik.errors.domain_and_industry ? (
                  <div className={styles.error}>
                    {formik.errors.domain_and_industry}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="carbon:account" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Last 4 Digit of SSN No"
                  variant="standard"
                  type="text"
                  name="ssn_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ssn_number}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "ssn_number" ||
                      formik.values.ssn_number !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("ssn_number");
                  }}
                />
                {formik.touched.ssn_number && formik.errors.ssn_number ? (
                  <div className={styles.error}>{formik.errors.ssn_number}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon
                    icon="clarity:clock-outline-badged"
                    height={25}
                    width={25}
                  />
                </Box>
                <TextField
                  select
                  id="standard-basic"
                  label="Best Time to Call"
                  variant="standard"
                  // type="datetime-local"
                  name="best_time_to_call"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.best_time_to_call}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "best_time_to_call" ||
                      formik.values.best_time_to_call !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("best_time_to_call");
                  }}
                >
                  {bestTimevalue.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.best_time_to_call &&
                formik.errors.best_time_to_call ? (
                  <div className={styles.error}>
                    {formik.errors.best_time_to_call}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiChairLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="carbon:account" height={25} width={25} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Time To Call"
                  variant="standard"
                  type="time"
                  name="best_time"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.best_time}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "best_time" || formik.values.best_time !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("best_time");
                  }}
                />
                {formik.touched.best_time && formik.errors.best_time ? (
                  <div className={styles.error}>{formik.errors.best_time}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  {/* <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} /> */}
                  <Icon icon="iconoir:time-zone" height={25} />
                </Box>
                <TextField
                  select
                  id="standard-basic"
                  label="Time Zone"
                  variant="standard"
                  name="time_zone"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.time_zone}
                  sx={fieldStyle}
                  InputLabelProps={{
                    shrink:
                      shrink === "time_zone" || formik.values.time_zone !== "", // Ensure shrink is true when focused or field has value
                  }}
                  onFocus={(e) => {
                    setShrink("time_zone");
                  }}
                >
                  {time_zone_choices.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.time_zone && formik.errors.time_zone ? (
                  <div className={styles.error}>{formik.errors.time_zone}</div>
                ) : null}
              </Grid>
            </Grid>
            <Box sx={{ backgroundColor: "#fff", padding: "15px 25px" }}>
              <Typography sx={{ marginBottom: "7px" }}>
                <b>Excellence in Skils </b>
              </Typography>
              <Typography>
                {getSkillNames(candidateListDetails?.skills)}
              </Typography>
            </Box>

            {profile?.profile?.role !== "BENCH_SALES_RECRUITER" &&
            formik.values?.p_tax_team?.includes("full_Time") ? (
              ""
            ) : (
              <Box
                className={styles.employer_details}
                sx={{ backgroundColor: "#dae3f2" }}
              >
                <Typography sx={{ color: customTextColor }}>
                  Employer’s Details
                </Typography>

                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiUserLight
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Employer’s Name"
                      variant="standard"
                      name="employer_manager_name"
                      onChange={handleEmployerFullNameChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.employer_manager_name}
                      sx={fieldStyle}
                    />
                    {formik.touched.employer_manager_name &&
                    formik.errors.employer_manager_name ? (
                      <div className={styles.error}>
                        {formik.errors.employer_manager_name}
                      </div>
                    ) : null}
                  </Grid>

                  {/* <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <PiBuildingOfficeLight
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Company Name"
                      variant="standard"
                      type="text"
                      name="employer_company_name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.employer_company_name}
                      sx={fieldStyle}
                    />
                  </Grid> */}

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Email ID"
                      variant="standard"
                      type="text"
                      name="employer_email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.employer_email}
                      sx={fieldStyle}
                    />
                    {formik.touched.employer_email &&
                    formik.errors.employer_email ? (
                      <div className={styles.error}>
                        {formik.errors.employer_email}
                      </div>
                    ) : null}
                  </Grid>

                  {/* <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                  >
                    <Box className={styles.icon_style}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: "#3f475a" }}
                      />
                    </Box>
                    <TextField
                      id="standard-basic"
                      label="Phone No"
                      variant="standard"
                      type="text"
                      name="employer_mobile_no"
                      onChange={handleEmployerMobileNoChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.employer_mobile_no}
                      sx={fieldStyle}
                    />
                  </Grid> */}
                </Grid>
              </Box>
            )}
          </form>

          <Box className={styles.add_candidate_btns}>
            <Box className={styles.add_back_btns}>
              <button
                onClick={handleOnCLickBack}
                style={{
                  border: "1.5px solid #4287f5",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                }}
                disabled={
                  trackerLoading === "loading" ||
                  internalSubStatus === "loading"
                }
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#4287f5" }}
                />
              </button>
            </Box>
            <button
              onClick={formik.handleSubmit}
              style={
                trackerLoading === "loading" || internalSubStatus === "loading"
                  ? {
                      backgroundColor: "#3856a6 ",
                      padding: "7px 40px",
                    }
                  : {
                      backgroundColor: "#3856a6 ",
                      padding: "5.5px 5px 5.5px 10px ",
                    }
              }
              disabled={
                trackerLoading === "loading" || internalSubStatus === "loading"
              }
            >
              {trackerLoading === "loading" || internalSubStatus === "loading"
                ? "Loading"
                : " Add Submission"}
              {trackerLoading !== "loading" &&
                internalSubStatus !== "loading" && (
                  <IoIosAdd style={{ fontSize: "25px", marginLeft: "5px" }} />
                )}
            </button>
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddCandidateInRequirementDrawer;
